import BaseUseCase from "../base_use_case.js";
class RegisterUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/registrations`,
      data: this.wrapParams(params, "user")
    });
  }
}

const instance = new RegisterUseCase();
export default instance;